import { render, staticRenderFns } from "./SubMenuLayerPesticides.vue?vue&type=template&id=2fc7aba6&scoped=true"
import script from "./SubMenuLayerPesticides.vue?vue&type=script&lang=js"
export * from "./SubMenuLayerPesticides.vue?vue&type=script&lang=js"
import style0 from "./SubMenuLayerPesticides.vue?vue&type=style&index=0&id=2fc7aba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7aba6",
  null
  
)

export default component.exports